import { render, staticRenderFns } from "./SpectrumPage.vue?vue&type=template&id=02ea6094&scoped=true&"
import script from "./SpectrumPage.vue?vue&type=script&lang=js&"
export * from "./SpectrumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea6094",
  null
  
)

export default component.exports